// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Signup Page - Modern Design */
.signup-container {
  max-width: 450px;
  margin: 0 auto;
  width: 100%;
  animation: fadeInUp 0.8s ease-out 0.6s both;
}

.signup-image {
  flex: 1 1;
  background: linear-gradient(135deg, #6616cd 0%, #b366ff 50%, #7d33e1 100%);
  position: relative;
  animation: slideInRight 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 3rem 2rem;
  overflow: hidden;
}

/* Enhanced Visual Effects for Signup Image */
.signup-image::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  width: 200%;
  height: 200%;
  background: 
    radial-gradient(circle at 70% 30%, rgba(255, 255, 255, 0.15) 0%, transparent 50%),
    radial-gradient(circle at 30% 70%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),
    radial-gradient(circle at 80% 80%, rgba(183, 102, 255, 0.3) 0%, transparent 50%);
  animation: floatingBubbles 25s ease-in-out infinite;
  z-index: 1;
}

.signup-image::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: 
    linear-gradient(135deg, transparent 20%, rgba(255, 255, 255, 0.08) 40%, transparent 60%);
  animation: shimmer 4s ease-in-out infinite;
  z-index: 2;
}

/* Floating Geometric Shapes for Signup */
.signup-image .geometric-shapes {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  pointer-events: none;
}

.geometric-shape {
  position: absolute;
  background: rgba(255, 255, 255, 0.12);
  animation: floatShape 18s infinite ease-in-out;
}

.shape-1 {
  width: 70px;
  height: 70px;
  border-radius: 50%;
  top: 15%;
  left: 10%;
  animation-delay: 0s;
}

.shape-2 {
  width: 50px;
  height: 50px;
  border-radius: 30%;
  top: 70%;
  right: 15%;
  animation-delay: 6s;
}

.shape-3 {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  top: 85%;
  left: 25%;
  animation-delay: 12s;
}

.shape-4 {
  width: 90px;
  height: 90px;
  border-radius: 25%;
  top: 5%;
  right: 5%;
  animation-delay: 9s;
}

.shape-5 {
  width: 45px;
  height: 45px;
  border-radius: 50%;
  top: 45%;
  left: 5%;
  animation-delay: 15s;
}

/* Form Content */
.signup-form-content {
  animation: fadeInUp 0.8s ease-out 0.6s both;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.form-row .form-group {
  margin-bottom: 0;
}

/* Ensure consistent spacing for all form elements */
.signup-form-content > .form-group,
.signup-form-content > .form-row,
.signup-form-content > .submit-container {
  margin-bottom: 1.5rem;
}

.signup-form-content > .form-group:last-of-type,
.signup-form-content > .form-row:last-of-type {
  margin-bottom: 1.5rem;
}

.submit-container {
  margin-top: 0.5rem;
  margin-bottom: 0;
}

/* Select Container */
.select-container {
  position: relative;
  width: 100%;
}

/* Submit Button Specific for Signup */
.signup-btn {
  width: 100%;
  padding: 1rem 1.5rem;
  background: linear-gradient(135deg, #6616cd, #b366ff);
  color: white;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  font-weight: 600;
  font-family: "Syne", sans-serif;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.signup-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
}

.signup-btn:hover::before {
  left: 100%;
}

.signup-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 25px rgba(102, 22, 205, 0.3);
}

.signup-btn:active {
  transform: translateY(0);
}

.signup-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
}

/* OTP Notification */
.otp-notification {
  background: linear-gradient(135deg, #e6f3ff, #f0f8ff);
  color: #0066cc;
  padding: 1rem 1.25rem;
  border-radius: 12px;
  margin-bottom: 1.5rem;
  text-align: center;
  font-size: 0.9rem;
  font-family: "Syne", sans-serif;
  font-weight: 500;
  border: 1px solid rgba(0, 102, 204, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  animation: slideDown 0.5s ease-out;
}

.notification-icon {
  width: 18px;
  height: 18px;
  color: #0066cc;
}

/* Error Messages */
.error-message {
  color: #dc2626;
  font-size: 0.8rem;
  margin-top: 0.5rem;
  font-family: "Syne", sans-serif;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 0.25rem;
  animation: fadeIn 0.3s ease-out;
}

.error-message::before {
  content: '⚠';
  font-size: 0.9rem;
}

/* Info Content for Right Side */
.signup-info {
  color: white;
  text-align: center;
  max-width: 400px;
  position: relative;
  z-index: 10;
  -webkit-backdrop-filter: blur(10px);
          backdrop-filter: blur(10px);
  background: rgba(255, 255, 255, 0.05);
  padding: 2rem;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}

.signup-info h2 {
  font-family: "Syne", sans-serif;
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 1.5rem;
  animation: fadeInUp 0.8s ease-out 0.2s both;
  background: linear-gradient(45deg, #ffffff, #f0f8ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.signup-info p {
  font-family: "Syne", sans-serif;
  font-size: 1.1rem;
  line-height: 1.6;
  margin-bottom: 2rem;
  opacity: 0.95;
  animation: fadeInUp 0.8s ease-out 0.4s both;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.signup-features {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: left;
}

.signup-features li {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.2rem;
  font-family: "Syne", sans-serif;
  font-size: 1rem;
  animation: fadeInUp 0.8s ease-out both;
  transition: transform 0.3s ease;
}

.signup-features li:hover {
  transform: translateX(5px);
}

.signup-features li:nth-child(1) { animation-delay: 0.6s; }
.signup-features li:nth-child(2) { animation-delay: 0.7s; }
.signup-features li:nth-child(3) { animation-delay: 0.8s; }
.signup-features li:nth-child(4) { animation-delay: 0.9s; }

.feature-icon {
  width: 28px;
  height: 28px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: all 0.3s ease;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.feature-icon:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: scale(1.1);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.feature-icon svg {
  width: 16px;
  height: 16px;
  color: white;
}

/* Enhanced Form Styling */
/* Staggered animations for form elements */
.signup-form-content > *:nth-child(1) {
  animation-delay: 0.1s;
}

.signup-form-content > *:nth-child(2) {
  animation-delay: 0.2s;
}

.signup-form-content > *:nth-child(3) {
  animation-delay: 0.3s;
}

.signup-form-content > *:nth-child(4) {
  animation-delay: 0.4s;
}

.signup-form-content > *:nth-child(5) {
  animation-delay: 0.5s;
}

.signup-form-content > *:nth-child(6) {
  animation-delay: 0.6s;
}

/* Enhanced Responsive Design for All Screen Sizes */

/* Extra Large Screens (1440px+) */
@media (min-width: 1440px) {
  .signup-container {
    max-width: 500px;
  }
  
  .signup-info h2 {
    font-size: 3rem;
  }
  
  .signup-info p {
    font-size: 1.2rem;
  }
  
  .signup-info {
    padding: 2.5rem;
    max-width: 450px;
  }
  
  .form-row {
    gap: 1.25rem;
  }
}

/* Large Screens (1200px - 1439px) */
@media (max-width: 1439px) and (min-width: 1200px) {
  .signup-container {
    max-width: 480px;
  }
  
  .signup-info {
    padding: 2rem;
    max-width: 420px;
  }
}

/* Medium-Large Screens (1024px - 1199px) */
@media (max-width: 1199px) and (min-width: 1024px) {
  .signup-container {
    max-width: 420px;
  }
  
  .form-row {
    gap: 0.875rem;
  }

  .signup-info h2 {
    font-size: 2.2rem;
  }

  .signup-info p {
    font-size: 1rem;
  }
  
  .signup-info {
    padding: 1.75rem;
    max-width: 380px;
  }
}

/* Tablets (768px - 1023px) */
@media (max-width: 1023px) and (min-width: 769px) {
  .signup-container {
    max-width: 400px;
  }
  
  .form-row {
    gap: 0.75rem;
  }
  
  .signup-image {
    padding: 2rem 1.5rem;
  }
  
  .signup-info {
    max-width: 350px;
    padding: 1.5rem;
  }
  
  .signup-info h2 {
    font-size: 2rem;
  }
  
  .signup-features li {
    font-size: 0.95rem;
  }
}

/* Mobile and Small Tablets (768px and below) */
@media (max-width: 768px) {
  .signup-container {
    max-width: 400px;
    margin: 0 auto;
  }
  
  .form-row {
    grid-template-columns: 1fr;
    gap: 0;
    margin-bottom: 1.5rem;
  }
  
  .form-row .form-group {
    margin-bottom: 1.5rem;
  }
  
  .form-row .form-group:last-child {
    margin-bottom: 0;
  }
  
  .signup-image {
    display: none;
  }
  
  .otp-notification {
    padding: 0.875rem 1rem;
    font-size: 0.85rem;
    margin-bottom: 1.5rem;
  }
  
  /* Maintain consistent spacing on mobile */
  .signup-form-content > .form-group,
  .signup-form-content > .form-row,
  .signup-form-content > .submit-container {
    margin-bottom: 1.5rem;
  }
}

/* Small Mobile (480px and below) */
@media (max-width: 480px) {
  .signup-container {
    max-width: 100%;
    padding: 0 1rem;
  }
  
  .signup-btn {
    padding: 0.875rem 1.25rem;
    font-size: 0.95rem;
}

.otp-notification {
    padding: 0.75rem 0.875rem;
    font-size: 0.8rem;
  }
}

/* Very Small Screens (320px and below) */
@media (max-width: 320px) {
  .signup-container {
    padding: 0 0.75rem;
  }
  
  .signup-btn {
    padding: 0.75rem 1rem;
  font-size: 0.9rem;
}

  .otp-notification {
    padding: 0.625rem 0.75rem;
    font-size: 0.75rem;
  }
}

/* Additional Animations */
@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(100%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

/* Enhanced Visual Effects Animations */
@keyframes floatingBubbles {
  0%, 100% {
    transform: translate(0, 0) rotate(0deg);
  }
  25% {
    transform: translate(-30px, 30px) rotate(90deg);
  }
  50% {
    transform: translate(20px, -20px) rotate(180deg);
  }
  75% {
    transform: translate(-20px, 10px) rotate(270deg);
  }
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%) translateY(-100%);
  }
  50% {
    transform: translateX(0%) translateY(0%);
  }
  100% {
    transform: translateX(100%) translateY(100%);
  }
}

@keyframes floatShape {
  0%, 100% {
    transform: translate(0, 0) rotate(0deg) scale(1);
    opacity: 0.7;
  }
  25% {
    transform: translate(-20px, 20px) rotate(90deg) scale(1.1);
    opacity: 0.9;
  }
  50% {
    transform: translate(15px, -15px) rotate(180deg) scale(0.9);
    opacity: 0.5;
  }
  75% {
    transform: translate(-15px, 10px) rotate(270deg) scale(1.05);
    opacity: 0.8;
  }
}

/* React Select Customizations for better integration */
.react-select__control {
  min-height: 48px !important;
  border: 2px solid #e5e7eb !important;
  border-radius: 12px !important;
  padding: 0.25rem 0.5rem !important;
  box-shadow: none !important;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
}

.react-select__control:hover {
  border-color: #6616cd !important;
}

.react-select__control--is-focused {
  border-color: #6616cd !important;
  box-shadow: 0 0 0 3px rgba(102, 22, 205, 0.1) !important;
}

.react-select__value-container {
  padding: 0.25rem 0.5rem !important;
}

.react-select__placeholder {
  color: #9ca3af !important;
  font-family: "Syne", sans-serif !important;
}

.react-select__single-value {
  color: #374151 !important;
  font-family: "Syne", sans-serif !important;
}

.react-select__menu {
  border-radius: 12px !important;
  border: 1px solid #e5e7eb !important;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1) !important;
  overflow: hidden !important;
}

.react-select__option {
  padding: 0.75rem 1rem !important;
  font-family: "Syne", sans-serif !important;
  transition: all 0.2s ease !important;
}

.react-select__option--is-focused {
  background: #f8f9ff !important;
  color: #374151 !important;
}

.react-select__option--is-selected {
  background: #6616cd !important;
  color: white !important;
}

.react-select__indicator-separator {
  display: none !important;
}

.react-select__dropdown-indicator {
  color: #6b7280 !important;
  transition: all 0.3s ease !important;
}

.react-select__dropdown-indicator:hover {
  color: #6616cd !important;
}

/* Input focus enhancement */
.signup-form-content .input-container input:focus {
  outline: none;
  border-color: #6616cd;
  box-shadow: 0 0 0 3px rgba(102, 22, 205, 0.1);
  transform: translateY(-1px);
}

/* Additional hover effects */
.signup-form-content .form-label:hover .label-icon {
  color: #7d33e1;
  transform: scale(1.1);
}

/* Progress indicator for multi-step form feel */
.form-progress {
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  margin-bottom: 2rem;
}

.progress-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #e5e7eb;
  transition: all 0.3s ease;
}

.progress-dot.active {
  background: linear-gradient(45deg, #6616cd, #b366ff);
  transform: scale(1.2);
}

.progress-dot.completed {
  background: #16a34a;
}

/* Enhanced floating elements for signup */
.signup-image .floating-elements {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}

.signup-image .floating-heart {
  position: absolute;
  width: 24px;
  height: 24px;
  opacity: 0.7;
  animation: float 8s ease-in-out infinite;
}

.signup-image .floating-heart::before,
.signup-image .floating-heart::after {
  content: '';
  position: absolute;
  width: 12px;
  height: 18px;
  background: linear-gradient(45deg, #6616cd, #b366ff);
  border-radius: 12px 12px 0 0;
  transform: rotate(-45deg);
  transform-origin: 0 100%;
}

.signup-image .floating-heart::after {
  left: 9px;
  transform: rotate(45deg);
  transform-origin: 100% 100%;
}

.signup-image .heart-1 {
  top: 15%;
  left: 10%;
  animation-delay: -1s;
  animation-duration: 6s;
}

.signup-image .heart-2 {
  top: 45%;
  right: 15%;
  animation-delay: -3s;
  animation-duration: 7s;
}

.signup-image .heart-3 {
  bottom: 25%;
  left: 20%;
  animation-delay: -2s;
  animation-duration: 8s;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Authentication/SignupPage.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,SAAO;EACP,0EAA0E;EAC1E,kBAAkB;EAClB,iEAAiE;EACjE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ;;;oFAGkF;EAClF,mDAAmD;EACnD,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;4FAC0F;EAC1F,0CAA0C;EAC1C,UAAU;AACZ;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,qCAAqC;EACrC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,oBAAoB;AACtB;;AAEA,iBAAiB;AACjB;EACE,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;;;EAGE,qBAAqB;AACvB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE,WAAW;EACX,oBAAoB;EACpB,qDAAqD;EACrD,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,iDAAiD;EACjD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,WAAW;EACX,YAAY;EACZ,sFAAsF;EACtF,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,qBAAqB;AACrB;EACE,qDAAqD;EACrD,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,wCAAwC;EACxC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,mCAA2B;UAA3B,2BAA2B;EAC3B,qCAAqC;EACrC,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,2CAA2C;EAC3C,oDAAoD;EACpD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,+BAA+B;EAC/B,eAAe;EACf,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mCAAmC,qBAAqB,EAAE;AAC1D,mCAAmC,qBAAqB,EAAE;AAC1D,mCAAmC,qBAAqB,EAAE;AAC1D,mCAAmC,qBAAqB,EAAE;;AAE1D;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA,0BAA0B;AAC1B,2CAA2C;AAC3C;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA,oDAAoD;;AAEpD,kCAAkC;AAClC;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;AACF;;AAEA,2CAA2C;AAC3C;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;EAClB;AACF;;AAEA,6BAA6B;AAC7B;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,gBAAgB;IAChB,cAAc;EAChB;;EAEA;IACE,0BAA0B;IAC1B,MAAM;IACN,qBAAqB;EACvB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA,0CAA0C;EAC1C;;;IAGE,qBAAqB;EACvB;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;EACnB;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB,iBAAiB;AACnB;;EAEE;IACE,yBAAyB;IACzB,kBAAkB;EACpB;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,uCAAuC;EACzC;EACA;IACE,+CAA+C;EACjD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,8CAA8C;EAChD;EACA;IACE,wCAAwC;EAC1C;EACA;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,gDAAgD;IAChD,YAAY;EACd;EACA;IACE,0DAA0D;IAC1D,YAAY;EACd;EACA;IACE,2DAA2D;IAC3D,YAAY;EACd;EACA;IACE,4DAA4D;IAC5D,YAAY;EACd;AACF;;AAEA,uDAAuD;AACvD;EACE,2BAA2B;EAC3B,oCAAoC;EACpC,8BAA8B;EAC9B,kCAAkC;EAClC,2BAA2B;EAC3B,4DAA4D;AAC9D;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,wDAAwD;AAC1D;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;EACzB,0CAA0C;AAC5C;;AAEA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,gCAAgC;EAChC,0CAA0C;EAC1C,oCAAoC;AACtC;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,oDAAoD;EACpD,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oDAAoD;EACpD,4BAA4B;EAC5B,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,wBAAwB;EACxB,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,QAAQ;EACR,UAAU;EACV,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,oBAAoB;EACpB,sBAAsB;AACxB","sourcesContent":["/* Signup Page - Modern Design */\n.signup-container {\n  max-width: 450px;\n  margin: 0 auto;\n  width: 100%;\n  animation: fadeInUp 0.8s ease-out 0.6s both;\n}\n\n.signup-image {\n  flex: 1;\n  background: linear-gradient(135deg, #6616cd 0%, #b366ff 50%, #7d33e1 100%);\n  position: relative;\n  animation: slideInRight 0.8s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem 2rem;\n  overflow: hidden;\n}\n\n/* Enhanced Visual Effects for Signup Image */\n.signup-image::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  width: 200%;\n  height: 200%;\n  background: \n    radial-gradient(circle at 70% 30%, rgba(255, 255, 255, 0.15) 0%, transparent 50%),\n    radial-gradient(circle at 30% 70%, rgba(255, 255, 255, 0.1) 0%, transparent 50%),\n    radial-gradient(circle at 80% 80%, rgba(183, 102, 255, 0.3) 0%, transparent 50%);\n  animation: floatingBubbles 25s ease-in-out infinite;\n  z-index: 1;\n}\n\n.signup-image::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: \n    linear-gradient(135deg, transparent 20%, rgba(255, 255, 255, 0.08) 40%, transparent 60%);\n  animation: shimmer 4s ease-in-out infinite;\n  z-index: 2;\n}\n\n/* Floating Geometric Shapes for Signup */\n.signup-image .geometric-shapes {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1;\n  pointer-events: none;\n}\n\n.geometric-shape {\n  position: absolute;\n  background: rgba(255, 255, 255, 0.12);\n  animation: floatShape 18s infinite ease-in-out;\n}\n\n.shape-1 {\n  width: 70px;\n  height: 70px;\n  border-radius: 50%;\n  top: 15%;\n  left: 10%;\n  animation-delay: 0s;\n}\n\n.shape-2 {\n  width: 50px;\n  height: 50px;\n  border-radius: 30%;\n  top: 70%;\n  right: 15%;\n  animation-delay: 6s;\n}\n\n.shape-3 {\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  top: 85%;\n  left: 25%;\n  animation-delay: 12s;\n}\n\n.shape-4 {\n  width: 90px;\n  height: 90px;\n  border-radius: 25%;\n  top: 5%;\n  right: 5%;\n  animation-delay: 9s;\n}\n\n.shape-5 {\n  width: 45px;\n  height: 45px;\n  border-radius: 50%;\n  top: 45%;\n  left: 5%;\n  animation-delay: 15s;\n}\n\n/* Form Content */\n.signup-form-content {\n  animation: fadeInUp 0.8s ease-out 0.6s both;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.form-row .form-group {\n  margin-bottom: 0;\n}\n\n/* Ensure consistent spacing for all form elements */\n.signup-form-content > .form-group,\n.signup-form-content > .form-row,\n.signup-form-content > .submit-container {\n  margin-bottom: 1.5rem;\n}\n\n.signup-form-content > .form-group:last-of-type,\n.signup-form-content > .form-row:last-of-type {\n  margin-bottom: 1.5rem;\n}\n\n.submit-container {\n  margin-top: 0.5rem;\n  margin-bottom: 0;\n}\n\n/* Select Container */\n.select-container {\n  position: relative;\n  width: 100%;\n}\n\n/* Submit Button Specific for Signup */\n.signup-btn {\n  width: 100%;\n  padding: 1rem 1.5rem;\n  background: linear-gradient(135deg, #6616cd, #b366ff);\n  color: white;\n  border: none;\n  border-radius: 12px;\n  font-size: 1rem;\n  font-weight: 600;\n  font-family: \"Syne\", sans-serif;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  position: relative;\n  overflow: hidden;\n}\n\n.signup-btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -100%;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\n  transition: left 0.5s ease;\n}\n\n.signup-btn:hover::before {\n  left: 100%;\n}\n\n.signup-btn:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 25px rgba(102, 22, 205, 0.3);\n}\n\n.signup-btn:active {\n  transform: translateY(0);\n}\n\n.signup-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* OTP Notification */\n.otp-notification {\n  background: linear-gradient(135deg, #e6f3ff, #f0f8ff);\n  color: #0066cc;\n  padding: 1rem 1.25rem;\n  border-radius: 12px;\n  margin-bottom: 1.5rem;\n  text-align: center;\n  font-size: 0.9rem;\n  font-family: \"Syne\", sans-serif;\n  font-weight: 500;\n  border: 1px solid rgba(0, 102, 204, 0.2);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  animation: slideDown 0.5s ease-out;\n}\n\n.notification-icon {\n  width: 18px;\n  height: 18px;\n  color: #0066cc;\n}\n\n/* Error Messages */\n.error-message {\n  color: #dc2626;\n  font-size: 0.8rem;\n  margin-top: 0.5rem;\n  font-family: \"Syne\", sans-serif;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  animation: fadeIn 0.3s ease-out;\n}\n\n.error-message::before {\n  content: '⚠';\n  font-size: 0.9rem;\n}\n\n/* Info Content for Right Side */\n.signup-info {\n  color: white;\n  text-align: center;\n  max-width: 400px;\n  position: relative;\n  z-index: 10;\n  backdrop-filter: blur(10px);\n  background: rgba(255, 255, 255, 0.05);\n  padding: 2rem;\n  border-radius: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);\n}\n\n.signup-info h2 {\n  font-family: \"Syne\", sans-serif;\n  font-size: 2.5rem;\n  font-weight: 700;\n  margin-bottom: 1.5rem;\n  animation: fadeInUp 0.8s ease-out 0.2s both;\n  background: linear-gradient(45deg, #ffffff, #f0f8ff);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n}\n\n.signup-info p {\n  font-family: \"Syne\", sans-serif;\n  font-size: 1.1rem;\n  line-height: 1.6;\n  margin-bottom: 2rem;\n  opacity: 0.95;\n  animation: fadeInUp 0.8s ease-out 0.4s both;\n  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.signup-features {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  text-align: left;\n}\n\n.signup-features li {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 1.2rem;\n  font-family: \"Syne\", sans-serif;\n  font-size: 1rem;\n  animation: fadeInUp 0.8s ease-out both;\n  transition: transform 0.3s ease;\n}\n\n.signup-features li:hover {\n  transform: translateX(5px);\n}\n\n.signup-features li:nth-child(1) { animation-delay: 0.6s; }\n.signup-features li:nth-child(2) { animation-delay: 0.7s; }\n.signup-features li:nth-child(3) { animation-delay: 0.8s; }\n.signup-features li:nth-child(4) { animation-delay: 0.9s; }\n\n.feature-icon {\n  width: 28px;\n  height: 28px;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: all 0.3s ease;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.feature-icon:hover {\n  background: rgba(255, 255, 255, 0.3);\n  transform: scale(1.1);\n  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);\n}\n\n.feature-icon svg {\n  width: 16px;\n  height: 16px;\n  color: white;\n}\n\n/* Enhanced Form Styling */\n/* Staggered animations for form elements */\n.signup-form-content > *:nth-child(1) {\n  animation-delay: 0.1s;\n}\n\n.signup-form-content > *:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.signup-form-content > *:nth-child(3) {\n  animation-delay: 0.3s;\n}\n\n.signup-form-content > *:nth-child(4) {\n  animation-delay: 0.4s;\n}\n\n.signup-form-content > *:nth-child(5) {\n  animation-delay: 0.5s;\n}\n\n.signup-form-content > *:nth-child(6) {\n  animation-delay: 0.6s;\n}\n\n/* Enhanced Responsive Design for All Screen Sizes */\n\n/* Extra Large Screens (1440px+) */\n@media (min-width: 1440px) {\n  .signup-container {\n    max-width: 500px;\n  }\n  \n  .signup-info h2 {\n    font-size: 3rem;\n  }\n  \n  .signup-info p {\n    font-size: 1.2rem;\n  }\n  \n  .signup-info {\n    padding: 2.5rem;\n    max-width: 450px;\n  }\n  \n  .form-row {\n    gap: 1.25rem;\n  }\n}\n\n/* Large Screens (1200px - 1439px) */\n@media (max-width: 1439px) and (min-width: 1200px) {\n  .signup-container {\n    max-width: 480px;\n  }\n  \n  .signup-info {\n    padding: 2rem;\n    max-width: 420px;\n  }\n}\n\n/* Medium-Large Screens (1024px - 1199px) */\n@media (max-width: 1199px) and (min-width: 1024px) {\n  .signup-container {\n    max-width: 420px;\n  }\n  \n  .form-row {\n    gap: 0.875rem;\n  }\n\n  .signup-info h2 {\n    font-size: 2.2rem;\n  }\n\n  .signup-info p {\n    font-size: 1rem;\n  }\n  \n  .signup-info {\n    padding: 1.75rem;\n    max-width: 380px;\n  }\n}\n\n/* Tablets (768px - 1023px) */\n@media (max-width: 1023px) and (min-width: 769px) {\n  .signup-container {\n    max-width: 400px;\n  }\n  \n  .form-row {\n    gap: 0.75rem;\n  }\n  \n  .signup-image {\n    padding: 2rem 1.5rem;\n  }\n  \n  .signup-info {\n    max-width: 350px;\n    padding: 1.5rem;\n  }\n  \n  .signup-info h2 {\n    font-size: 2rem;\n  }\n  \n  .signup-features li {\n    font-size: 0.95rem;\n  }\n}\n\n/* Mobile and Small Tablets (768px and below) */\n@media (max-width: 768px) {\n  .signup-container {\n    max-width: 400px;\n    margin: 0 auto;\n  }\n  \n  .form-row {\n    grid-template-columns: 1fr;\n    gap: 0;\n    margin-bottom: 1.5rem;\n  }\n  \n  .form-row .form-group {\n    margin-bottom: 1.5rem;\n  }\n  \n  .form-row .form-group:last-child {\n    margin-bottom: 0;\n  }\n  \n  .signup-image {\n    display: none;\n  }\n  \n  .otp-notification {\n    padding: 0.875rem 1rem;\n    font-size: 0.85rem;\n    margin-bottom: 1.5rem;\n  }\n  \n  /* Maintain consistent spacing on mobile */\n  .signup-form-content > .form-group,\n  .signup-form-content > .form-row,\n  .signup-form-content > .submit-container {\n    margin-bottom: 1.5rem;\n  }\n}\n\n/* Small Mobile (480px and below) */\n@media (max-width: 480px) {\n  .signup-container {\n    max-width: 100%;\n    padding: 0 1rem;\n  }\n  \n  .signup-btn {\n    padding: 0.875rem 1.25rem;\n    font-size: 0.95rem;\n}\n\n.otp-notification {\n    padding: 0.75rem 0.875rem;\n    font-size: 0.8rem;\n  }\n}\n\n/* Very Small Screens (320px and below) */\n@media (max-width: 320px) {\n  .signup-container {\n    padding: 0 0.75rem;\n  }\n  \n  .signup-btn {\n    padding: 0.75rem 1rem;\n  font-size: 0.9rem;\n}\n\n  .otp-notification {\n    padding: 0.625rem 0.75rem;\n    font-size: 0.75rem;\n  }\n}\n\n/* Additional Animations */\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateY(30px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes slideInRight {\n  from {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n/* Enhanced Visual Effects Animations */\n@keyframes floatingBubbles {\n  0%, 100% {\n    transform: translate(0, 0) rotate(0deg);\n  }\n  25% {\n    transform: translate(-30px, 30px) rotate(90deg);\n  }\n  50% {\n    transform: translate(20px, -20px) rotate(180deg);\n  }\n  75% {\n    transform: translate(-20px, 10px) rotate(270deg);\n  }\n}\n\n@keyframes shimmer {\n  0% {\n    transform: translateX(-100%) translateY(-100%);\n  }\n  50% {\n    transform: translateX(0%) translateY(0%);\n  }\n  100% {\n    transform: translateX(100%) translateY(100%);\n  }\n}\n\n@keyframes floatShape {\n  0%, 100% {\n    transform: translate(0, 0) rotate(0deg) scale(1);\n    opacity: 0.7;\n  }\n  25% {\n    transform: translate(-20px, 20px) rotate(90deg) scale(1.1);\n    opacity: 0.9;\n  }\n  50% {\n    transform: translate(15px, -15px) rotate(180deg) scale(0.9);\n    opacity: 0.5;\n  }\n  75% {\n    transform: translate(-15px, 10px) rotate(270deg) scale(1.05);\n    opacity: 0.8;\n  }\n}\n\n/* React Select Customizations for better integration */\n.react-select__control {\n  min-height: 48px !important;\n  border: 2px solid #e5e7eb !important;\n  border-radius: 12px !important;\n  padding: 0.25rem 0.5rem !important;\n  box-shadow: none !important;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n\n.react-select__control:hover {\n  border-color: #6616cd !important;\n}\n\n.react-select__control--is-focused {\n  border-color: #6616cd !important;\n  box-shadow: 0 0 0 3px rgba(102, 22, 205, 0.1) !important;\n}\n\n.react-select__value-container {\n  padding: 0.25rem 0.5rem !important;\n}\n\n.react-select__placeholder {\n  color: #9ca3af !important;\n  font-family: \"Syne\", sans-serif !important;\n}\n\n.react-select__single-value {\n  color: #374151 !important;\n  font-family: \"Syne\", sans-serif !important;\n}\n\n.react-select__menu {\n  border-radius: 12px !important;\n  border: 1px solid #e5e7eb !important;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1) !important;\n  overflow: hidden !important;\n}\n\n.react-select__option {\n  padding: 0.75rem 1rem !important;\n  font-family: \"Syne\", sans-serif !important;\n  transition: all 0.2s ease !important;\n}\n\n.react-select__option--is-focused {\n  background: #f8f9ff !important;\n  color: #374151 !important;\n}\n\n.react-select__option--is-selected {\n  background: #6616cd !important;\n  color: white !important;\n}\n\n.react-select__indicator-separator {\n  display: none !important;\n}\n\n.react-select__dropdown-indicator {\n  color: #6b7280 !important;\n  transition: all 0.3s ease !important;\n}\n\n.react-select__dropdown-indicator:hover {\n  color: #6616cd !important;\n}\n\n/* Input focus enhancement */\n.signup-form-content .input-container input:focus {\n  outline: none;\n  border-color: #6616cd;\n  box-shadow: 0 0 0 3px rgba(102, 22, 205, 0.1);\n  transform: translateY(-1px);\n}\n\n/* Additional hover effects */\n.signup-form-content .form-label:hover .label-icon {\n  color: #7d33e1;\n  transform: scale(1.1);\n}\n\n/* Progress indicator for multi-step form feel */\n.form-progress {\n  display: flex;\n  justify-content: center;\n  gap: 0.5rem;\n  margin-bottom: 2rem;\n}\n\n.progress-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: #e5e7eb;\n  transition: all 0.3s ease;\n}\n\n.progress-dot.active {\n  background: linear-gradient(45deg, #6616cd, #b366ff);\n  transform: scale(1.2);\n}\n\n.progress-dot.completed {\n  background: #16a34a;\n}\n\n/* Enhanced floating elements for signup */\n.signup-image .floating-elements {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n}\n\n.signup-image .floating-heart {\n  position: absolute;\n  width: 24px;\n  height: 24px;\n  opacity: 0.7;\n  animation: float 8s ease-in-out infinite;\n}\n\n.signup-image .floating-heart::before,\n.signup-image .floating-heart::after {\n  content: '';\n  position: absolute;\n  width: 12px;\n  height: 18px;\n  background: linear-gradient(45deg, #6616cd, #b366ff);\n  border-radius: 12px 12px 0 0;\n  transform: rotate(-45deg);\n  transform-origin: 0 100%;\n}\n\n.signup-image .floating-heart::after {\n  left: 9px;\n  transform: rotate(45deg);\n  transform-origin: 100% 100%;\n}\n\n.signup-image .heart-1 {\n  top: 15%;\n  left: 10%;\n  animation-delay: -1s;\n  animation-duration: 6s;\n}\n\n.signup-image .heart-2 {\n  top: 45%;\n  right: 15%;\n  animation-delay: -3s;\n  animation-duration: 7s;\n}\n\n.signup-image .heart-3 {\n  bottom: 25%;\n  left: 20%;\n  animation-delay: -2s;\n  animation-duration: 8s;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
